import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { DEFAULT_IMG_ALT } from "../../../constants";
import { ImageUtil } from "../../../utils";

import { P_Props } from "./ToppingCard1.type";

const ToppingCard1Presenter: React.FC<P_Props> = (props) => {
  return (
    <div className="topping-card-1">
      <div className="topping-card-1__img">
        <LazyLoadImage alt={DEFAULT_IMG_ALT} src={ImageUtil.buildToppingImgSrc(props.data.picture)} />
      </div>
      <div className="topping-card-1__info">{props.data.name}</div>
    </div>
  );
};

export default ToppingCard1Presenter;
